import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { ReactComponent as Icon } from "../svg/burger.svg";

export default function BurgerIcon(props: SvgIconProps) {
  return <SvgIcon {...props} component={Icon} inheritViewBox fontSize="inherit" />;
}
